import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import List from "../List";
import Item from "../Item";
import rehydrator from "../Item/Item.rehydrator";

var Expandable = /*#__PURE__*/function (_Item) {
  _inherits(Expandable, _Item);

  var _super = _createSuper(Expandable);

  function Expandable() {
    _classCallCheck(this, Expandable);

    return _super.apply(this, arguments);
  }

  return Expandable;
}(Item);

_defineProperty(Expandable, "Item", Item);

_defineProperty(Expandable, "List", List);

_defineProperty(Expandable, "rehydrator", rehydrator);

export { Expandable as default };